module.exports = __webpack_public_path__ + "img/bmcl_gallery6.7d410a9f.jpg";